module.exports = __webpack_public_path__ + "static/media/logo.87f68a63.png";